import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { commonPostPutApi } from "../../../redux/reducers/commonApiSlice";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import CommonHeadingNBtns from "../../common-components/CommonHeadingNBtns";
import { getCurrentDate } from "../../common-data/Converts";
import SelectDropdown from "../../components-react/SelectDropdown";
import { timeSlots } from "../../common-data/DropdowData";
import { fetchTrainerBySlotData } from "../../../redux/reducers/dropdownApiSlice";

const TrialAssignForm = ({
  rowData,
  closeModal,
  userInfoData,
  callFunction,
}) => {
  const dispatch = useDispatch();
  const { trainersDataBySlot } = useSelector((state) => state.dropdown);

  const [allTrainers, setAllTrainers] = useState([]);
  const defaultTrainer =
    (rowData?.default_trainer_name || rowData?.trainer_name) &&
    (rowData?.trainer_id || rowData?.default_trainer_id)
      ? {
          label: "(Current Assigned Trainer)",
          value: rowData?.default_trainer_id || rowData?.trainer_id,
          info: {
            trainer_name:
              rowData?.default_trainer_name || rowData?.trainer_name,
            total_active_pt: "-",
          },
        }
      : null;

  const initialFormValues = {
    trialDate: "",
    selectedSlot: "",
    selectedTrainer: defaultTrainer || "",
    clickedTrainerId: defaultTrainer?.value || "",
  };
  const [formValues, setFormValues] = useState(initialFormValues);
  const [formErrors, setFormErrors] = useState({});

  const onCloseForm = () => {
    setFormValues(initialFormValues);
    setAllTrainers([]);
    setFormErrors({});
    closeModal();
  };

  function getTrainersBySlot(filter) {
    dispatch(
      fetchTrainerBySlotData({
        filters: filter,
        token: userInfoData?.token,
      })
    );
  }

  // const getAllTrainers = () => {
  //   const trainers = [...(trainersDataBySlot || [])];

  //   if (
  //     defaultTrainer &&
  //     !trainers.find((trainer) => trainer.value === defaultTrainer.value)
  //   ) {
  //     trainers.unshift(defaultTrainer);
  //   }

  //   return trainers;
  // };

  const onChangeInput = (e) => {
    const { name, value, type, checked } = e.target;
    setFormValues((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const onChangeDropdown = (name, value) => {
    if (name === "selectedSlot") {
      setFormValues((prev) => ({
        ...prev,
        selectedTrainer: "",
        clickedTrainerId: "",
        [name]: value,
      }));
    } else
      setFormValues((prev) => ({
        ...prev,
        [name]: value,
      }));
  };

  const validateForm = (values) => {
    const errors = {};

    if (!values.trialDate) {
      errors.trialDate = "required!";
    }

    if (!values.selectedSlot) {
      errors.selectedSlot = "required!";
    }

    if (!values.selectedTrainer) {
      errors.selectedTrainer = "required!";
    }

    if (!values.clickedTrainerId) {
      errors.clickedTrainerId = "required!";
    }

    return errors;
  };

  const handleSubmitForm = async (payload) => {
    const method = "POST";
    const endpoint = "/ptTrial/assign_three_day_trial";
    const token = userInfoData?.token || "";

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        setFormValues(initialFormValues);
        setAllTrainers([]);
        setFormErrors({});
        callFunction();
        closeModal();
        toast.success(result?.payload?.message || "Success!");
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const errors = validateForm(formValues);
    setFormErrors(errors);

    if (Object.keys(errors).length === 0) {
      const [start, end] = formValues.selectedSlot?.value?.split("-");

      const userData = {
        user_id: rowData?.user_id || "",
        trainer_id: formValues.clickedTrainerId || "",
        threeday_start_date: formValues.trialDate || "",
        threeday_slot_start: start || "",
        threeday_slot_end: end || "",
      };

      const handleConfirm = async () => {
        handleSubmitForm(userData);
      };

      showConfirmAlert(
        handleConfirm,
        `Confirm Before Assigning The Trial!`,
        "Edit Form",
        "Submit Form"
      );
    }
  };

  useEffect(() => {
    if (formValues.selectedSlot) {
      const [start, end] = formValues.selectedSlot?.value?.split("-");

      const filters = {
        gym_id: userInfoData?.gym_id || rowData?.gym_id || "",
        slot_start_time: start,
        slot_end_time: end,
        //   gym_id: "gmLs0oo0lC21t",
        //   slot_start_time: "06:00",
        //   slot_end_time: "07:00",
      };

      getTrainersBySlot(filters);
    }
  }, [formValues.selectedSlot]);

  useEffect(() => {
    if (formValues.selectedSlot && trainersDataBySlot?.length > 0) {
      let trainers = [...trainersDataBySlot];

      if (
        defaultTrainer &&
        !trainers.find((trainer) => trainer.value === defaultTrainer.value)
      ) {
        trainers.unshift(defaultTrainer);
      }

      setAllTrainers(trainers);

      //   if (defaultTrainer) {
      //     setFormValues((prev) => ({
      //       ...prev,
      //       selectedTrainer: {
      //         label: defaultTrainer.info.trainer_name,
      //         value: defaultTrainer.value,
      //       },
      //       clickedTrainerId: defaultTrainer.value,
      //     }));
      //   }
    } else if (defaultTrainer) {
      setAllTrainers([defaultTrainer]);
      setFormValues((prev) => ({
        ...prev,
        selectedTrainer: {
          label: defaultTrainer.info.trainer_name,
          value: defaultTrainer.value,
        },
        clickedTrainerId: defaultTrainer.value,
      }));
    } else {
      setAllTrainers([]);
      setFormValues((prev) => ({
        ...prev,
        selectedTrainer: "",
        clickedTrainerId: "",
      }));
    }
  }, [formValues.selectedSlot, trainersDataBySlot]);

  return (
    <>
      <CommonHeadingNBtns
        title={`Assign 3 day PT trial`}
        onClose={onCloseForm}
        btnTxt={"submit"}
        onClick={onSubmit}
      />

      <form className="formContainer three-day-trial-form" onSubmit={onSubmit}>
        <div className="formInputsGrid twoGridSystem">
          <div className="formInputBox">
            <label htmlFor="trialDate" className="formInputLabel">
              start Date <span className="required">*</span>
            </label>

            <div className={`commonInputWrapper`} style={{ width: "100%" }}>
              <input
                type="date"
                className={`formInput ${
                  formValues.trialDate ? "date-has-value" : ""
                } ${formErrors.trialDate ? "formError" : ""}`}
                name="trialDate"
                value={formValues.trialDate}
                onChange={onChangeInput}
                min={getCurrentDate()}
              />
            </div>
          </div>

          <div className="formInputBox">
            <label htmlFor="selectedSlot" className="formInputLabel">
              Select Slot <span className="required">*</span>
            </label>

            <div
              className={`commonWrapper ${
                formErrors.selectedSlot ? "formError" : ""
              }`}
            >
              <SelectDropdown
                options={timeSlots}
                selectedOption={formValues.selectedSlot}
                setSelectedOption={(selectedValue) =>
                  onChangeDropdown("selectedSlot", selectedValue)
                }
                name="Slot"
              />
            </div>
          </div>

          {/* {formValues.selectedSlot ? ( */}
          <div className="formInputBox span2">
            <label htmlFor="selectedTrainer" className="formInputLabel">
              Trainer <span className="required">*</span>
            </label>

            {allTrainers?.length > 0 ? (
              <div
                className={`availble-trainer-slotwise ${
                  formErrors.selectedTrainer ? "formError" : ""
                }`}
              >
                {allTrainers?.map((item, index) => (
                  <div
                    className={`trainerbox ${
                      formValues.clickedTrainerId === item?.value
                        ? "active"
                        : ""
                    }`}
                    key={index}
                    onClick={() => {
                      setFormValues((prevs) => {
                        const isCurrentlySelected =
                          prevs.clickedTrainerId === item?.value;

                        return {
                          ...prevs,
                          selectedTrainer: isCurrentlySelected
                            ? ""
                            : {
                                label: item?.info?.trainer_name || "NA",
                                value: item?.value || "",
                              },
                          clickedTrainerId: isCurrentlySelected
                            ? ""
                            : item?.value,
                        };
                      });
                    }}
                  >
                    <span className="name">
                      {item?.info?.trainer_name || "NA"}
                    </span>
                    <span className="shifts">{item?.label || "-"}</span>
                    <span className="value">
                      Ongoing PT: {item?.info?.total_active_pt || 0}
                    </span>
                  </div>
                ))}
              </div>
            ) : (
              <span className="info">No Trainer Available On This Slot</span>
            )}

            {allTrainers?.length > 0 && formErrors.selectedTrainer ? (
              <span className="info-red">
                Trainer Is Not Selected. Click On The Trainer To Select Trainer.
              </span>
            ) : null}
          </div>
          {/* ) : null} */}
        </div>
      </form>
    </>
  );
};

export default TrialAssignForm;
